module.exports = {"id":"186452","name":"Siem de Jong","rating":"75","photo":"./data/images/photos/4/186452.png","club":{"name":"Ajax","logo":"./data/images/clubs/Ajax.png"},"positions":["MC","MOC","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SiemdeJong0.json
// module id = 3951
// module chunks = 0